import axios from 'axios';

const api = axios.create({
  baseURL: 'https://fbanking.banese.com.br/denuncias/mail_denuncias.php',
  headers: { 'Content-Type': 'multipart/form-data' },
});

// api.interceptors.request.use((req) => {
//   console.log(req);
// });
export default api;
